module.exports = __webpack_public_path__ + "static/media/AoA_CloseUp_20.1eb8fa37.jpg";